'use strict';

var _ = require('lodash');
var LogitSharesDataService = function LogitSharesDataService($q, $log, calibrationAnalysisConstants, liteDataService, onlineLogitCalibrationDataCacheService) {
  function getMaxRTP(origin, destination) {
    var filters = 'origin==' + origin + ';destination==' + destination;
    return getHepData(calibrationAnalysisConstants.ENDPOINT_URL.HEP_URL, filters, calibrationAnalysisConstants.HEP_TYPE_RTP).then(function (hepList) {
      var rtpData = hepList[0];
      return _.chain(rtpData.properties.readingDays).map('days').max().value();
    });
  }
  function getLogitHepProfiles(logitSharesRequest) {
    var url;
    var hepFilter = 'origin==\'' + logitSharesRequest.origin + '\';destination==\'' + logitSharesRequest.destination + '\';significantPOS==\'' + logitSharesRequest.significantPos + '\'';
    if (_.isUndefined(logitSharesRequest.scenarioName)) {
      url = calibrationAnalysisConstants.ENDPOINT_URL.HEP_ALL_NAME_URL;
    } else {
      url = calibrationAnalysisConstants.ENDPOINT_URL.HEP_ALL_URL;
      hepFilter += ';scenarioName==\'' + logitSharesRequest.scenarioName + '\'';
    }
    return getHepData(url, hepFilter, calibrationAnalysisConstants.HEP_TYPE_LOGIT, logitSharesRequest.calibrationName).then(function (response) {
      return response;
    });
  }
  function getPublishedLogitProfiles(logitSharesRequest) {
    var hepFilter = 'origin==\'' + logitSharesRequest.origin + '\';destination==\'' + logitSharesRequest.destination + '\';dayOfWeek==\'' + logitSharesRequest.dayOfWeek + '\';classSetId==\'' + logitSharesRequest.classGroup + '\'' + ';significantPOS==\'' + logitSharesRequest.significantPos + '\';scenarioName==\'PUBLISHED\'';
    return getHepData(calibrationAnalysisConstants.ENDPOINT_URL.HEP_ALL_URL, hepFilter, calibrationAnalysisConstants.HEP_TYPE_LOGIT).then(function (response) {
      return _.isEmpty(response) ? undefined : response[0];
    });
  }
  function getServices(logitSharesRequest) {
    var servicesFilter = 'origin==\'' + logitSharesRequest.origin + '\';destination==\'' + logitSharesRequest.destination + '\';dow==\'' + logitSharesRequest.dayOfWeek + '\';departureDate=ge=' + logitSharesRequest.dateRangeStart + ';departureDate=le=' + logitSharesRequest.dateRangeEnd;
    var requestParams = {
      filter: servicesFilter,
      pageLimit: 100000,
      page: 1
    };
    var endpoint = calibrationAnalysisConstants.ENDPOINT_URL.SERVICES;
    var cachedData = onlineLogitCalibrationDataCacheService.getData(endpoint, requestParams);
    $log.debug('Service Data cache available? ' + !_.isUndefined(cachedData));
    var promise = cachedData ? $q.when(cachedData) : liteDataService.get(endpoint, requestParams);
    return promise.then(function (response) {
      onlineLogitCalibrationDataCacheService.putData(endpoint, requestParams, response);
      return response.services;
    });
  }
  function getHepData(baseUrl, filters, type, calibrationName) {
    var request = {
      pageLimit: calibrationAnalysisConstants.DEFAULT_PAGE_LIMIT,
      filter: filters,
      attributeName: 'properties.calibrationName',
      attributeValue: calibrationName
    };
    var endpoint = baseUrl + type;
    var cachedData = onlineLogitCalibrationDataCacheService.getData(endpoint, request);
    $log.debug('Cache exists for Hep Url ' + endpoint + '? ' + !_.isUndefined(cachedData));
    var promise = cachedData ? $q.when(cachedData) : liteDataService.get(endpoint, request);
    return promise.then(function (response) {
      onlineLogitCalibrationDataCacheService.putData(endpoint, request, response);
      return response.hepList;
    });
  }
  function publishProfiles(calibrationData, scenarioName) {
    var endpointUrl = calibrationData.active === calibrationAnalysisConstants.CALIBRATION_STATUSES.INACTIVE ? calibrationAnalysisConstants.ENDPOINT_URL.REPUBLISH : calibrationAnalysisConstants.ENDPOINT_URL.PUBLISH;
    var market = calibrationData.market.split('-');
    var payLoad = {
      type: 'Logit',
      origin: market[0],
      destination: market[1],
      scenarioName: scenarioName,
      attributeName: 'properties.calibrationName',
      attributeValue: calibrationData.calibrationName
    };
    return liteDataService.put(endpointUrl, payLoad).then(function (response) {
      return response;
    });
  }
  function saveLogitProfiles(logitProfiles) {
    var payload = {
      value: logitProfiles
    };
    return liteDataService.put(calibrationAnalysisConstants.ENDPOINT_URL.SAVE, payload).then(function (response) {
      return response;
    });
  }
  function updateLogitCalibration(updateRequest) {
    return liteDataService.put(calibrationAnalysisConstants.ENDPOINT_URL.UPDATE, updateRequest).then(function (response) {
      return response;
    });
  }
  function invalidateCache() {
    onlineLogitCalibrationDataCacheService.invalidate();
  }
  return {
    getMaxRTP: getMaxRTP,
    getLogitHepProfiles: getLogitHepProfiles,
    getPublishedLogitProfiles: getPublishedLogitProfiles,
    getServices: getServices,
    invalidateCache: invalidateCache,
    publishProfiles: publishProfiles,
    saveLogitProfiles: saveLogitProfiles,
    updateLogitCalibration: updateLogitCalibration
  };
};
LogitSharesDataService.$inject = ['$q', '$log', 'CalibrationAnalysisConstants', 'LiteDataService', 'OnlineLogitCalibrationDataCacheService'];
module.exports = LogitSharesDataService;